<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-anti-disgust`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.157 2.829l39.598 39.597a1 1 0 010 1.415l-1.414 1.414a1 1 0 01-1.415 0L3.328 5.657a1 1 0 010-1.414l1.415-1.414a1 1 0 011.414 0zm4.687 15.024a2.018 2.018 0 011.476 2.454c-.066.25-.107.509-.123.767a4.516 4.516 0 002.16 4.142 2.015 2.015 0 01.889 2.268 2.046 2.046 0 01-1.957 1.47h-1.157c-2.51 0-4.556 2.026-4.556 4.513C7.576 35.953 9.62 38 12.132 38h19.297l4 4H12.132C7.372 42 3.5 38.164 3.5 33.45c0-3.674 2.356-6.823 5.649-8.025a8.488 8.488 0 01-1.02-4.618c.033-.5.115-1.01.237-1.494a2.04 2.04 0 012.478-1.461zM30.888 5.775A2.03 2.03 0 0029.282 5h-1.867c-2.6 0-5.061 1.13-6.74 3.092a8.631 8.631 0 00-1.757 3.255l3.807 3.806c.032-.21.03-.423-.005-.635a4.652 4.652 0 011.06-3.818 4.734 4.734 0 012.87-1.607l-.213.832a5.558 5.558 0 001.02 4.803 5.673 5.673 0 004.327 2.172c2.307.267 4.068 2.26 4.019 4.578-.025 1.51-.88 2.898-2.266 3.721a2 2 0 00-.43.337l3.475 3.473c1.955.306 3.502 1.851 3.793 3.794l3.597 3.598c.341-.918.528-1.91.528-2.943 0-3.689-2.364-6.838-5.673-8.032a8.197 8.197 0 001.06-3.876 8.479 8.479 0 00-2.193-5.869 8.625 8.625 0 00-5.576-2.81c-.065-.008-.122-.008-.187-.008a1.6 1.6 0 01-1.247-.613 1.548 1.548 0 01-.285-1.348l.855-3.4a2 2 0 00-.366-1.727z"/></svg>
</template>
<script>

export default {
  name: 'IconAntiDisgust',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
